module.exports = __webpack_public_path__ + "img/zs4.957c3d5e.png";